import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url-search-params.js";
//@ts-ignore
import { parsePoints, removeDuplicatePoints } from "@utils/MapUtils";
//@ts-ignore
import { encodeCookie } from "@utils/CookieUtils";
//@ts-ignore
import { buildURL, buildParams } from "@utils/RESBUrlBuilder/RESB_UrlBuilder";
//@ts-ignore
import { replaceAll } from "@utils/StringUtils";
//@ts-ignore
import { useSearchBeanStore } from "@store/SearchBeanStore";
export function useSearch() {
  var searchBeanStore = useSearchBeanStore();
  var search = function search() {
    var withRedirect = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    var customListingTypologyURL = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
    var useContractType = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    var agencyFilterParameters = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
    var freeSearch = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
    var _a, _b, _c, _d, _e, _f, _g;
    // eslint-disable-next-line max-len
    if (!searchBeanStore.searchBean.cityURL && !searchBeanStore.searchBean.polygonFromMap && !agencyFilterParameters || !(searchBeanStore.searchBean.listingTypologyURL || customListingTypologyURL) || useContractType && !searchBeanStore.searchBean.contractType) {
      if (!freeSearch) {
        console.error("cannot search");
        return "";
      }
    }
    var URL = "";
    if (freeSearch) {
      URL += "/cerca";
      // Andrea M: when new search the city must be empty without any filter
      // eslint-disable-next-line max-len
      URL += buildURL("", searchBeanStore.searchBean.listingTypologyURL || "", searchBeanStore.searchBean.contractType, searchBeanStore.searchBean.zoneURL, replaceAll(replaceAll(freeSearch.value, "[.]", ""), "\\s+", "-"));
      URL += buildParams(searchBeanStore.searchBean);
      if (URL && withRedirect)
        //@ts-ignore
        window.location.href = window._baseURL + URL;
      // @ts-ignore
      return window._baseURL + URL;
    }
    var cityURL;
    if (!((_a = searchBeanStore.searchBean) === null || _a === void 0 ? void 0 : _a.cityURL) && agencyFilterParameters) {
      cityURL = "";
    } else if ((_b = searchBeanStore.searchBean) === null || _b === void 0 ? void 0 : _b.cityURL) {
      cityURL = (_c = searchBeanStore.searchBean) === null || _c === void 0 ? void 0 : _c.cityURL;
    } else {
      cityURL = "ricerca";
    }
    var agencyUri;
    if (((_d = searchBeanStore.searchBean) === null || _d === void 0 ? void 0 : _d.cityURL) && agencyFilterParameters) {
      // @ts-ignore
      agencyUri = agencyFilterParameters.uri;
    }
    if (searchBeanStore.searchBean.zoneIdList && ((_e = searchBeanStore.searchBean.zoneIdList) === null || _e === void 0 ? void 0 : _e.length) > 0) URL = buildURL(cityURL, customListingTypologyURL ? customListingTypologyURL : searchBeanStore.searchBean.listingTypologyURL || "", useContractType ? searchBeanStore.searchBean.contractType : null, searchBeanStore.searchBean.zoneURL, undefined, agencyUri !== null && agencyUri !== void 0 ? agencyUri : "", null);else URL = buildURL(cityURL, customListingTypologyURL ? customListingTypologyURL : searchBeanStore.searchBean.listingTypologyURL || "", useContractType ? searchBeanStore.searchBean.contractType : null, searchBeanStore.searchBean.zoneURL, undefined, agencyUri !== null && agencyUri !== void 0 ? agencyUri : "", searchBeanStore.searchBean.districtURL);
    if (!customListingTypologyURL) {
      URL += buildParams(searchBeanStore.searchBean);
    } else if (agencyFilterParameters != null) {
      if (!((_f = searchBeanStore.searchBean) === null || _f === void 0 ? void 0 : _f.cityURL) && agencyFilterParameters)
        // @ts-ignore
        URL += agencyFilterParameters.uri ? (agencyFilterParameters === null || agencyFilterParameters === void 0 ? void 0 : agencyFilterParameters.uri) + "/" : "";
      // @ts-ignore
      URL += agencyFilterParameters.name ? "ricerca/?Nome=".concat(agencyFilterParameters.name) : "";
    }
    var delimiter = URL.indexOf("?") > -1 ? "&" : "?";
    if (searchBeanStore.searchBean.polygonFromMap) {
      /*  Handling polygon arriving from backend with POLYGIN((***)) format */
      if (searchBeanStore.searchBean.polygonFromMap.indexOf("POLYGON") > -1) {
        var points = removeDuplicatePoints(parsePoints(searchBeanStore.searchBean.polygonFromMap) || []);
        if (points) {
          searchBeanStore.searchBean.polygonFromMap = points.map(point => "".concat(point.lat, ",").concat(point.lng, ";")).join("");
        }
      }
      //@ts-ignore
      URL += "".concat(delimiter, "Poligono=").concat(encodeURIComponent(searchBeanStore.searchBean.polygonFromMap));
    } else if (!searchBeanStore.searchBean.zoneURL && searchBeanStore.searchBean.zoneIdList && searchBeanStore.searchBean.zoneIdList.length > 1) {
      URL += "".concat(delimiter, "zoneID=").concat(searchBeanStore.searchBean.zoneIdList.join("&zoneID="));
    }
    if (searchBeanStore.searchBean.districtIdList && (searchBeanStore.searchBean.districtIdList.length > 1 ||
    // eslint-disable-next-line max-len
    searchBeanStore.searchBean.districtIdList.length === 1 && (searchBeanStore.searchBean.zoneIdList && ((_g = searchBeanStore.searchBean.zoneIdList) === null || _g === void 0 ? void 0 : _g.length) >= 1 || searchBeanStore.searchBean.zoneId))) {
      delimiter = URL.indexOf("?") > -1 ? "&" : "?";
      URL += delimiter + "districtID=" + searchBeanStore.searchBean.districtIdList.join("&districtID=");
    }
    /* qui se ho più di un listing typology genero l`array */
    if (searchBeanStore.searchBean.listingTypologyIdList && searchBeanStore.searchBean.listingTypologyIdList.length > 1 && !customListingTypologyURL) {
      delimiter = URL.indexOf("?") > -1 ? "&" : "?";
      URL += delimiter + "listingTypologyID=" + searchBeanStore.searchBean.listingTypologyIdList.join("&listingTypologyID=");
    }
    encodeCookie("newSearch", true);
    if (URL && withRedirect)
      //@ts-ignore
      window.location.href = window._baseURL + URL;
    return window._baseURL + URL;
  };
  var setOrderAndSearch = opt => {
    searchBeanStore.searchBean.filterOrderId = opt.id;
    search();
  };
  var setOrderAndSearchInAgency = opt => {
    var urlSearchPar = new URLSearchParams(window.location.search);
    if (opt.id) {
      urlSearchPar.set("Ordinamento", String(opt.id));
    }
    window.location.href = location.protocol + "//" + location.host + "/" + location.pathname + "?" + urlSearchPar.toString();
  };
  return {
    search,
    setOrderAndSearch,
    setOrderAndSearchInAgency
  };
}